import React from "react";

const formatDate = (timestamp, mx_contract) => {
  let _timestamp = mx_contract ? timestamp : timestamp * 1000;
  return new Date(_timestamp).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

const formatCurrency = (amount, currency, mx_contract) => {
  let _amount = mx_contract ? amount : amount/100;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
  }).format(_amount);
};

const formatInterval = (interval, interval_count) => {
  if (interval === 'day' && interval_count <= 28) return 'monthly';
  return 'quarterly';
};

const ConsultationSubscriptionDetails = ({ subscription, firstMonthPay }) => {
  const {
    status,
    current_period_start,
    current_period_end,
    cancel_at,
    plan,
    collection_method,
    mx_contract,
  } = subscription;

  return (
    <div className="bg-white rounded-lg p-6 border">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-5">
        <div className="space-y-2">
          <p className="text-sm text-gray-600">Status</p>
          <p className="font-medium text-sm">
            <span
              className={`inline-block px-2 py-1 rounded-full text-sm ${
                status.toLowerCase() === "active"
                  ? "bg-green-100 text-green-800"
                  : status.toLowerCase() === "canceled"
                  ? "bg-red-100 text-red-800"
                  : "bg-yellow-100 text-yellow-800"
              }`}
            >
              {status.charAt(0).toUpperCase() + status.slice(1)}
            </span>
          </p>
        </div>

        <div className="space-y-2">
          <p className="text-sm text-gray-600">Plan</p>
          <p className="font-medium text-sm">
            {formatCurrency(plan.amount, "USD", mx_contract)}/month
          </p>
        </div>

        {firstMonthPay && (
        <div className="space-y-2">
          <p className="text-sm text-gray-600">First month pay</p>
          <p className="font-medium text-sm">
            {formatCurrency(firstMonthPay, "USD", mx_contract)}
          </p>
        </div>
        )}

        {current_period_start && (
          <div className="space-y-2">
            <p className="text-sm text-gray-600">Current Period</p>
            <p className="font-medium text-sm">
              {formatDate(current_period_start, mx_contract)} -{" "}
              {formatDate(current_period_end, mx_contract)}
            </p>
          </div>
        )}

        <div className="space-y-2">
          <p className="text-sm text-gray-600">Collection Method</p>
          <p className="font-medium capitalize text-sm">
            {collection_method.replace("_", " ")}
          </p>
        </div>

        {cancel_at && (
          <div className="space-y-2 col-span-full">
            <p className="text-sm text-gray-600">Cancellation</p>
            <p className="font-medium text-red-600 text-sm">
              Subscription will be canceled on {formatDate(cancel_at)}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConsultationSubscriptionDetails;
